export const LESSONS = [
  {
    id: 'lesson-1',
    title: 'الموارد المعدنية',
    titleEn: 'الموارد المعدنية',
    icon: '🪙',
    color: '#D4AF37',
    description: 'تعرف على الذهب والفوسفات والحديد والنحاس وأماكن وجودها في مصر',
    duration: '25 دقيقة',
    sections: 4,
    quiz: 18,
    points: 40
  },
  {
    id: 'lesson-2',
    title: 'مصادر الطاقة',
    titleEn: 'مصادر الطاقة',
    icon: '⚡',
    color: '#1E88E5',
    description: 'استكشف البترول والغاز والطاقة الشمسية والرياح والكهرومائية',
    duration: '25 دقيقة',
    sections: 4,
    quiz: 18,
    points: 40
  },
  {
    id: 'lesson-3',
    title: 'المياه والزراعة',
    titleEn: 'المياه والزراعة',
    icon: '🌾',
    color: '#66BB6A',
    description: 'تعلم دورة المياه في مصر وأهم المحاصيل وطرق الري',
    duration: '25 دقيقة',
    sections: 4,
    quiz: 18,
    points: 40
  }
];
